import { getBootSnapshot, recoverBoot } from '#~/routes/root/boot-budget.js';
import { ElectronAPI } from '#~/electron/index.js';
// ENG-4154: read the IdentityState store, not a per-consumer bridge poll.
import { resolveLinkedAgentId } from '#~/electron/index.js';
import { isElectronApp } from '#~/electron/utils.js';
import { Paths } from '#~/routes/constants.js';
import { Centered } from '@studio/design-system/overlay';
import { Spinner } from '@studio/design-system/spinner';
import { vendorName } from '@studio/design-system/themes/vendor.js';
import type { Agent } from '@studio/models/agent';
import { useTimer } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

/** `<Restart>` component. */
export const Restart = (): ReactElement => {
  const navigate = useNavigate();
  const segs = window.location.href.split('/');
  const agentID = segs[segs.length - 1];

  // Wait a few seconds for the the agent to be restarted.  The launcher does not provide us with any useful feedback, so this is @fixme hack.
  useTimer(async () => {
    const isElectronAgentRestart = isElectronApp() && (await resolveLinkedAgentId()) === agentID;

    if (agentID !== undefined) {
      navigate(Paths.agent.resolve(agentID as Agent['id']));

      if (isElectronAgentRestart) {
        ElectronAPI.onReloadStudio();
        return;
      }

      if (getBootSnapshot()) void recoverBoot('reload');
      else window.location.reload();
      return;
    }

    if (isElectronAgentRestart) {
      ElectronAPI.onReloadStudio();
      return;
    }

    if (getBootSnapshot()) void recoverBoot('reload');
    else window.location.reload();

    return () => {};
  }, 5e3);

  return (
    <Centered>
      <div className='flex items-center gap-8 text-xl'>
        <Spinner /> Restarting {vendorName()} Bridge...
      </div>
    </Centered>
  );
};
